import type { AuthProviderProps } from 'react-oidc-context'
import { env } from '@/infra/config/env'

const FRONTEND_URL = globalThis.location.origin

export const oidcConfig: AuthProviderProps = {
  authority: `${env.KEYCLOAK_BASE_URL}/realms/${env.KEYCLOAK_REALM}`,
  client_id: env.KEYCLOAK_CLIENT_ID,
  redirect_uri: `${FRONTEND_URL}/auth/callback`,
  post_logout_redirect_uri: FRONTEND_URL,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  silent_redirect_uri: `${FRONTEND_URL}/silent-renew.html`,
  silentRequestTimeoutInSeconds: env.OIDC_SILENT_REQUEST_TIMEOUT_MS / 1000,
  accessTokenExpiringNotificationTimeInSeconds: env.OIDC_TOKEN_EXPIRING_NOTIFICATION_SECONDS,
  loadUserInfo: true,
  monitorSession: true,
}
